import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Subscription } from "./subscription.model";

/**
 * @class PaymentDetail
 *
 */
export class PaymentDetail extends Model {

    static get TYPE_CREDIT_CARD() {

        return 1;
    }

    static get TYPE_PAYPAL() {

        return 2;
    }

    static get TYPE_SADAD() {

        return 3;
    }

    static get TYPE_CASH_CHEQUE() {

        return 4;
    }

    static get TYPE_POS() {

        return 6;
    }

    static get TYPE_BANK_TRANSFER() {

        return 7;
    }

    static get TYPE_CASH() {

        return 4;
    }

    static get TYPE_CHEQUE() {

        return 5;
    }

    static get TYPE_BY_CUSTOMER() {

        return 9;
    }
    
    static get FORMATTED_TYPES() {

        return {
            [this.TYPE_CREDIT_CARD]: 'CREDIT_CARD',
            [this.TYPE_PAYPAL]: 'PAYPAL',
            [this.TYPE_SADAD]: 'SADAD',
            [this.TYPE_CASH_CHEQUE]: 'CASH_CHEQUE',
            [this.TYPE_POS]: 'POS',
            [this.TYPE_BANK_TRANSFER]: 'BANK_TRANSFER',
            [this.TYPE_BY_CUSTOMER]: 'E_PAYMENT_BY_CUSTOMER',
            [this.TYPE_CHEQUE]: 'CHEQUE',
            [this.TYPE_CASH]: 'CASH',
        };
    }

    isCreditCard() {

        return this.type && this.type === this.constructor.TYPE_CREDIT_CARD;
    }
    
    formatType() {
        
        return this.type ? this.constructor.FORMATTED_TYPES[this.type] : this.type;
    }

    /**
     * @param {Object|PaymentDetail} value
     * @returns {PaymentDetail}
     */
    setSubscription(value) {

        return value instanceof Subscription ? value : new Subscription(value);
    }

    getTypeLabel() {

        switch (this.type) {

            case this.constructor.TYPE_CREDIT_CARD:

                return 'CREDIT_CARD';

            case this.constructor.TYPE_PAYPAL:

                return 'PAYPAL';

            case this.constructor.TYPE_SADAD:

                return 'SADAD';

            case this.constructor.TYPE_CASH_CHEQUE:

                return 'CASH_CHEQUE';

            case this.constructor.TYPE_POS:

                return 'POS';

            case this.constructor.TYPE_BANK_TRANSFER:

                return 'BANK_TRANSFER';
        }
    }
}

AccessorsMutatorsDecorator('id', 'subscription', 'subscription_id', 'type', 'cc_type', 'cc_number', 'cc_cardholder_name',
    'cc_month', 'cc_year', 'cc_cvv', 'property_name', 'property_name_ar', 'cc_number_unsecured', 'finish',
    'date', 'amount_paid', 'cheque_number', 'reference_number', 'bank', 'pos_reference', 'bank_transfer_reference', 'paytabs_transaction', 'amount_total')(PaymentDetail);


// WEBPACK FOOTER //
// ./src/pms-api/models/payment-detail.model.js